require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./reusable-custom-card-widget.json") })
        }
      }, "path---reusable-custom-card-widget");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---reusable-custom-card-widget!./.cache/json/reusable-custom-card-widget.json
// module id = 405
// module chunks = 231608221292675